/* eslint-disable no-param-reassign */
import ContentService, { generateImageUrl, generateVideoUrl } from '../../assets/js/amplience-content-service';

export const makeImage = slide => ({
  type: 'image',
  url: generateImageUrl(slide.image),
  altText: slide.imageAltText,
  link: slide.link
});

export const makeBanner = slide => ({
  type: 'banner',
  url: generateImageUrl(slide.banner.image),
  altText: slide.banner.imageAltText,
  link: slide.link
});

export const makeVideo = slide => ({
  type: 'video',
  url: generateVideoUrl(slide.video)
});

export const formatSlides = ({ slides }) => {
  const newSlidesArray = [];
  const slidesArray = Object.keys(slides).map(key => slides[key]);
  slidesArray.forEach((slide) => {
    const { image, banner, video } = slide;
    if (image) {
      newSlidesArray.push(makeImage(slide));
    }
    if (banner && banner.image) {
      newSlidesArray.push(makeBanner(slide));
    }
    if (video) {
      newSlidesArray.push(makeVideo(slide));
    }
  });
  return newSlidesArray;
};

export const formatOptions = ({ loop, navigationDots, speed, transitionType }) => ({
  nav: navigationDots,
  autoplay: loop,
  mode: transitionType === 'slide' ? 'carousel' : 'gallery',
  speed
});

export default class SliderContentService extends ContentService {
  formatSliderContent() {
    return this.getContent().then((formatted) => {
      this.content = {};
      this.content.options = formatOptions(formatted);
      this.content.slides = formatSlides(formatted);
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/slider/slider-content.js